import { storyblokEditable } from '@storyblok/react'
import { ImageGridItemStoryblok } from '@/component-types-sb'

export default function ImageGridItem({ blok }: { blok: ImageGridItemStoryblok }) {
  return <div {...storyblokEditable(blok)} />
}
